module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_03_6DB79_1SB_H2G.6f44da8a.jpg";